import { mutatorAction } from 'satcheljs';
import type { SearchServiceEventMap } from '@metaos/hub-sdk';
import getStore from '../store/appHostSearchStore';

export interface OnAppAddSearchEventListenerActionMessage {
    eventName: keyof SearchServiceEventMap;
    eventListener: any;
}
export const onAppAddSearchEventListenerMutator: (
    eventName: keyof SearchServiceEventMap,
    eventListener: any
) => void = mutatorAction(
    'onAppAddSearchEventListener',
    (eventName: keyof SearchServiceEventMap, eventListener: any): void => {
        const store = getStore();
        store.isSearchEnabled = true;
        store.eventRegistrationsMap.set(eventName, eventListener);
    }
);
